module.exports = __webpack_public_path__ + "static/media/galerija_2019 (21).3b7ddc80.jpg";